import { StopIteration } from "@axioscode/api-client/lib/utils/APIResponse";
import createAsyncAction from "utils/createAsyncAction";
import dotProp from "dot-prop-immutable";

import { forTypeahead } from "editor/actions/metadata";
import Log from "utils/log";

export const GET_TAGS_REQUESTED = "GET_TAGS_REQUESTED";
export const GET_TAGS_SUCCEEDED = "GET_TAGS_SUCCEEDED";
export const GET_TAGS_FAILED = "GET_TAGS_FAILED";

export const getTagsAsync = filter => (dispatch, getState, getClient) => {
  const api = getClient(dispatch, getState);

  dispatch({
    type: GET_TAGS_REQUESTED,
    payload: filter,
  });

  return api.tags
    .list({ counts: 1, ...filter })
    .then(response => {
      const {
        settings: {
          tags: { meta },
        },
      } = getState();
      if (meta.filter === filter) {
        return dispatch({
          type: GET_TAGS_SUCCEEDED,
          payload: response,
        });
      }
    })
    .catch(error => {
      Log.logger(error, "error", undefined, true);
      dispatch({
        type: GET_TAGS_FAILED,
        payload: error,
        error: true,
      });
    });
};

export const TOGGLE_TAG_SELECTION = "TOGGLE_TAG_SELECTION";
export const toggleTagSelection = tag => {
  return {
    type: TOGGLE_TAG_SELECTION,
    payload: tag,
  };
};

export const RESET_TAG_STATE = "RESET_TAG_STATE";
export const resetTagState = () => {
  return {
    type: RESET_TAG_STATE,
  };
};

export const GET_TRENDING_TOPICS_REQUESTED = "GET_TRENDING_TOPICS_REQUESTED";
export const GET_TRENDING_TOPICS_SUCCEEDED = "GET_TRENDING_TOPICS_SUCCEEDED";
export const GET_TRENDING_TOPICS_FAILED = "GET_TRENDING_TOPICS_FAILED";

export const getTrendingTopicsAsync = createAsyncAction(
  "tags",
  "list",
  "GET_TRENDING_TOPICS",
  () => ({
    ordering: "-recent_stories,name",
    page_size: 8,
    counts: 1,
  })
);

export const GET_TAGS_NEXT_PAGE_REQUESTED = "GET_TAGS_NEXT_PAGE_REQUESTED";
export const GET_TAGS_NEXT_PAGE_SUCCEEDED = "GET_TAGS_NEXT_PAGE_SUCCEEDED";
export const GET_TAGS_NEXT_PAGE_FAILED = "GET_TAGS_NEXT_PAGE_FAILED";

export const getTagsNextPageRequested = () => {
  return {
    type: GET_TAGS_NEXT_PAGE_REQUESTED,
  };
};

export const getTagsNextPageSucceeded = response => {
  return {
    type: GET_TAGS_NEXT_PAGE_SUCCEEDED,
    payload: response,
  };
};

export const getTagsNextPageFailed = error => {
  Log.logger(error, "error", undefined, true);

  return {
    type: GET_TAGS_NEXT_PAGE_FAILED,
    payload: error,
    error: true,
  };
};

export const getTagsNextPageAsync = () => {
  return (dispatch, getState) => {
    const {
      settings: { tags },
    } = getState();

    // Only dispatch a next page call if there is a response stored in state which is paginated
    if (dotProp.get(tags, "meta.response.count")) {
      const {
        meta: { response, filter },
      } = tags;

      return response
        .next()
        .then(tags => {
          // Only dispatch getTagsNextPageRequested if the getTagsNextPageAsync's filter is the same as in state.
          const {
            settings: {
              tags: { meta },
            },
          } = getState();

          if (meta.filter === filter) {
            dispatch(getTagsNextPageSucceeded(tags));
          }
        })
        .catch(error => {
          // Don't resolve in this catch - throw up to Tag's _handleInfiniteLoad
          // because this isn't really an error, but we want to use a catch() to handle it still
          if (error instanceof StopIteration) {
            throw error;
          }

          dispatch(getTagsNextPageFailed(error));
        });
    } else {
      return Promise.resolve();
    }
  };
};

export const CREATE_TAG_REQUESTED = "CREATE_TAG_REQUESTED";
export const CREATE_TAG_SUCCEEDED = "CREATE_TAG_SUCCEEDED";
export const CREATE_TAG_FAILED = "CREATE_TAG_FAILED";

export const createTagAsync = createAsyncAction(
  "tags",
  "create",
  "CREATE_TAG",
  args => args,
  error => {
    throw error;
  }
);

export const GET_TAG_TYPES_LIST_REQUESTED = "GET_TAG_TYPES_LIST_REQUESTED";
export const GET_TAG_TYPES_LIST_SUCCEEDED = "GET_TAG_TYPES_LIST_SUCCEEDED";
export const GET_TAG_TYPES_LIST_FAILED = "GET_TAG_TYPES_LIST_FAILED";

export const getTagTypesListAsync = createAsyncAction(
  "tags",
  "listTypes",
  "GET_TAG_TYPES_LIST",
  () => ({})
);

export const getTagTypesListAsyncForTypeahead = forTypeahead(
  getTagTypesListAsync
);

export const DELETE_TAG_REQUESTED = "DELETE_TAG_REQUESTED";
export const DELETE_TAG_SUCCEEDED = "DELETE_TAG_SUCCEEDED";
export const DELETE_TAG_FAILED = "DELETE_TAG_FAILED";

export const deleteTagsAsync = createAsyncAction(
  "tags",
  "delete",
  "DELETE_TAG",
  args => args,
  error => {
    throw error;
  }
);

export const MERGE_TAGS_REQUESTED = "MERGE_TAGS_REQUESTED";
export const MERGE_TAGS_SUCCEEDED = "MERGE_TAGS_SUCCEEDED";
export const MERGE_TAGS_FAILED = "MERGE_TAGS_FAILED";

export const mergeTagsAsync = createAsyncAction(
  "tags",
  "merge",
  "MERGE_TAGS",
  args => args,
  error => {
    throw error;
  }
);
